import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import VueMask from "v-mask";
import VeeValidate from "vee-validate";
import Promise from "es6-promise";
import VueAnalytics from "vue-analytics";
import VTooltip from 'v-tooltip';
import VModal from "vue-js-modal";

import Vuetify from "vuetify";
import VueMaterial from "vue-material";

import { default as msalPlugin } from "vue-msal-browser";
import "vue-material/dist/vue-material.min.css";
import "vuetify/dist/vuetify.min.css";

Vue.use(VTooltip)
Vue.use(VModal);
Vue.use(VueMaterial);
Vue.use(Vuetify)
Promise.polyfill();

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENTID,
    authority: process.env.VUE_APP_MSAL_AUTHORITY,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECTURI,
    //postLogoutRedirectUri: process.env.VUE_APP_MSAL_LOGOUTURI,
    knownAuthorities: [process.env.VUE_APP_MSAL_KNOWNAUTHORITY],
    //navigateToLoginRequestUrl: false
    scopes:process.env.VUE_APP_MSAL_SCOPES,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  graph: {
    url: 'https://graph.microsoft.com/v1.0/me',
    scopes: ['user.read'],
    response_type: "blob"
  },
  mode: "redirect"
}

Vue.use(msalPlugin, msalConfig);

Vue.config.API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
Vue.config.HOST_URL = process.env.VUE_APP_HOST_URL;
Vue.config.productionTip = false;
Vue.use(VueMask);
Vue.use(VeeValidate);
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_KEY,
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
});

var instance = axios.create({
  baseURL: Vue.config.API_ENDPOINT,
  timeout: 30000,
  headers: {
    "X-Custom-Header": "Essilor Sampling",
    "common": {
      "Authorization": `Bearer ${localStorage.token}`
    }
  }
});

window.axios = instance;

axios.interceptors.request.use(async function(req) {
  const token = await auth.getAccessToken();
  const programKey = localStorage.programKey
  localStorage.token = token;
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  if(programKey){
    req.headers.programKey = programKey;
  }
  return req;
}, function(err) {
  return Promise.reject(err);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");